import entries from 'object.entries';

const currencies = {
  'usd' : "&#36;",
  'euro' : "&#8364;",
  'yen': "&#165;",
  'rub' : "&#8381;",
  'uah' : "&#8372;",
  'franc': "&#8355;"
};


const get_currency = (mosaicName) => {
    const currency_ent = entries(currencies);
    for (let currency of currency_ent) {
      if (mosaicName.indexOf(currency[0].toLowerCase()) !== -1) {
        return currency[1];
      }
    }
    return currencies['euro'];
};

export {get_currency}
